<template>
  <section>
    <div
      id="managewarehouse"
      class="modal modal-right fade footer-fix"
      data-backdrop="static"
      role="dialog"
    >
      <div
        class="modal-dialog modal-lg-900"
      >
        <div class="modal-content">
          <div class="bg-dark modal-header">
            <h5 class="modal-title">
              <span>
                {{ $t("Manage Warehouse") }}
              </span>
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-3 pt-1">
            <div v-if="onload">
              <div class="content">
                <placeholder-content is-load="true" />
              </div>
            </div>
            <div v-else>
              <div v-if="!hasPermission">
                <access-denied />
              </div>
              <div v-if="hasPermission">
                <div class="mx-n3 pb-2">
                  <legend class="font-weight-semibold h6 px-3">
                    <i class="fa-solid fa-box-taped mr-2" />{{ $t("Warehouse Information") }}
                  </legend>
                </div>
                <div
                  class="alert alert-danger border-0 alert-dismissible"
                  :style="'background-color:#DBEEFD; color:#2196F3; padding-right: 0px!important'"
                >
                  <span class="font-weight-semibold"><i class="fa-solid fa-circle-exclamation mr-2 mt-1" /></span>{{ $t("Exceeds the maximum warehouse limit") }} {{ $parent.limitWarehouses }} {{ $t('warehouses for your plan. Please select a warehouse based on your plan limits to continue using it.') }}
                </div>
                <div class="pb-2">{{$t('Warehouse Limits:')}}
                  <span class="text-green-600">{{ $parent.limitWarehouses }}</span>
                  {{$t('Channels')}}
                </div>
                <div
                  class="table-responsive mt-0 data-nowrap border"
                    id="vuetable-warehosue"
                  >
                  <div :class="['vuetable-wrapper ui basic segment', loading]">
                    <vuetable
                      :no-data-template="$t('No Data Available')"
                      class="dataTable thead-bg-fafafa table-hover"
                      :data-manager="dataManager"
                      :api-mode="false"
                      :class="['min-w-2048']"
                      @vuetable:loading="showLoader"
                      @vuetable:loaded="hideLoader"
                      :append-params="queryParams"
                      ref="vuetable"
                      data-path="data"
                      :fields="fields"
                      pagination-path=""
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:initialized="onInitialized"
                      @vuetable:checkbox-toggled="toggleCheckboxs"
                      @vuetable:checkbox-toggled-all="toggleAllCheckboxes"
                    >
                    <template
                        slot="warehouse_number"
                        slot-scope="props"
                    >
                      {{ props.rowData.warehouse_number }}
                      <template v-if="props.rowData.is_default">
                        <span class="ml-2 badge badge-success pointer-cursor">
                          <i class="fa fa-sm fa-star mr-1" />{{ $t("Default") }}
                        </span>
                      </template>
                    </template>
                      <template
                        slot="name"
                        slot-scope="props"
                      >
                        {{ props.rowData.name }}
                      </template>
                      <template
                        slot="status"
                        slot-scope="props"
                      >
                        <div
                          v-html="warehouseStatus(props.rowData.status)"
                        />
                      </template>
                    </vuetable>
                  </div>
                </div>
                <div class="datatable-footer border">
                  <vuetable-pagination-info
                    class="dataTables_info"
                    ref="paginationInfo"
                    :no-data-template="$t('No relevant data')"
                    :info-template="$t('Displaying {from} to {to} of {total} items')"
                  />
                  <component
                    class="dataTables_paginate paging_simple_numbers"
                    :is="paginationComponent"
                    ref="pagination"
                    @vuetable-pagination:change-page="onChangePage"
                  />
                </div>
              </div>
              <div
                class="modal-footer fixed-bottom bg-light border-bottom justify-content-center">
                <div v-if="hasPermission">
                  <button
                    type="button"
                    class="btn btn-primary"
                    :disabled="(loading != 'loading' && selectedBulk.length <= $parent.limitWarehouses) ? false : true"
                    @click="submitWarehouse"
                  >
                    <i class="fa-solid fa-circle-check mr-1" />
                    {{ $t("Confirm") }} {{ selectedBulk.length }}/{{ $parent.limitWarehouses }}
                  </button>
                  <button
                    type="button"
                    class="mx-2 btn btn-light"
                    data-dismiss="modal"
                    :disabled="loading != ''"
                  >
                    {{ $t("Cancel") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  initialFilter,
  tabLabel,
} from "./Params.js";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Api from "@/services/endpoint/tenant.service";
import Cookies from "js-cookie";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo.vue";
import FieldsWarehouse from "./FieldsDef.js";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";


export default {
  components: {
    VueSlickCarousel,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    PlaceholderContent,
    AccessDenied
  },
  data() {
    return {
      paginationComponent: "vuetable-pagination",
      user: JSON.parse(Cookies.get('user')),
      fields: FieldsWarehouse,
      multiSort: true,
      perPage: 10,
      countAll: 0,
      onload: false,
      onloadPage: false,
      hasPermission: true,
      loading: "",
      warehouseDataPlanLimit: [],
      selectedTo: [],
      selectedBulk: [],
      warehouseList: [],
      warehouseIds: [],
      warehouseDefault: null,
      filters: initialFilter(),
      tabLabel: tabLabel(),
      queryParams: {},
      dateRange: {
        startDate: null,
        endDate: null,
      },
      tenant: JSON.parse(Cookies.get('tenant')),
      totalUsageWarehouse: 0,
      selectWarehouseAll: false,
      warehouseCheckList: []
    };
  },
  mounted() {
    $.each(this.$parent.announcements, function (key, val) {
      if (document.cookie && document.cookie.indexOf(`notify-later-${val.id}`) != -1) {
        // console.log("log:No");
      } else {
        // $(`#announcement${val.id}`).modal('show');
        // console.log("announcement");
        $("#managewarehouse").modal("show");
        $(".modal").on("shown.bs.modal", function () {
          if ($(".modal-backdrop").length > 1) {
            $(".modal-backdrop").not(":first").remove();
          }
        });
      }
    });

    if(navigator.appVersion.indexOf("Win")!=-1){
      $('.btn-page-contain').css('line-height','16px');
    }
  },
  methods: {
    managePlan(e) {
      this.$emit('manageWarehouse', e);
    },
    dataManager(sortOrder, pagination) {
      if (sortOrder.length > 0) {
        this.filters.sort = sortOrder
          .map((item) => `${item.sortField}|${item.direction}`)
          .join(",");
      }
      this.setParams();
    },
    setPerPage(perPage) {
      this.filters.limit = perPage;
      this.setParams();
    },
    showLoader() {
      this.loading = "loading";
    },
    hideLoader() {
      this.loading = "";
    },
    onPaginationData(tablePagination) {
      this.$refs.paginationInfo.setPaginationData(tablePagination);
      this.$refs.pagination.setPaginationData(tablePagination);
    },
    onInitialized(fields) {
      this.vuetableFields = fields.filter((field) => field.togglable);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async setParams(page) {
      let response = '';

      this.loading = "loading";
      this.$refs.vuetable.resetData();
      if (this.dateRange.startDate && this.dateRange.endDate) {
          var afterStartDate = this.dateRange.startDate + ' 00:00:00';
          var afterEndDate = this.dateRange.endDate + ' 23:59:59';
          this.filters.start = convertTimezone.localToUtc(afterStartDate);
          this.filters.end = convertTimezone.localToUtc(afterEndDate);
      }
      if(page){
        this.filters.page = page;
      }else{
        this.filters.page = this.$refs.vuetable.currentPage;
      }
      if (this.filters.search != null || (this.filters.start && this.filters.end)) {
        this.showTotalFilter = true;
      } else {
        this.showTotalFilter = false;
      }
      // this.queryParams.limit = this.filters['limit'];
      this.queryParams.limit = 500;
      this.queryParams.page = this.filters['page'];
      this.queryParams.search = this.filters['search'];
      this.queryParams.end = this.filters['end'];
      this.queryParams.start = this.filters['start'];
      this.queryParams.sort = this.filters['sort'];

      let queryString = "";
      if (this.queryParams) {
        queryString += "?" + $.param(this.queryParams);
      }
      try {
        response = await Api.Inventory.getWarehousePlanLimit(queryString);
        let warehouseActive = response.data.viewpoint_cnt.active
        this.totalUsageWarehouse = response.data.limit;
        this.warehouseCheckList = response.data.data;
        (() => {
          if (this.warehouseDataPlanLimit.length) {
            response.data.data.forEach((item, index) => {
              const itemLimit = this.warehouseDataPlanLimit.find((itemLimit) => itemLimit.id === item.id)
              item.is_limit = itemLimit.is_limit
            })
          }

          if (!this.warehouseDataPlanLimit.length) {
            response.data.data.sort((a, b) => {
              if (a.is_default !== b.is_default) {
                return a.is_default ? -1 : 1;
              }
              return a.id - b.id;
            });

            let limit = parseInt(response.data.limit);

            response.data.data.forEach((item) => {
              if (limit) {
                if (item.is_default) {
                  item.is_limit = false
                  limit--
                  return
                }

                item.is_limit = false
                limit--
                return
              }
              item.is_limit = true
            });

            response.data.data.sort((a, b) => b.id - a.id);

            this.warehouseDataPlanLimit = response.data.data
          }
        })

        let data = this.$storeIndex.mutations.vueTableFormatJson(response);
        this.totalFilter = response.data.meta.total;
        let viewpoint = response.data.viewpoint_cnt;
        this.countAll = viewpoint.all;
        this.warehouseList = data.data;
        this.warehouseIds = this.warehouseList.map(item => item.id);
        this.warehouseDefault = this.warehouseList.filter(el => el.is_default);
        this.$refs.vuetable.selectedTo.push(this.warehouseDefault[0].id);
        this.selectedBulk.push(this.warehouseDefault[0].id)
        if(data.hasOwnProperty('viewpoint_cnt')) {
          Object.keys(viewpoint).forEach(key => {
            this.tabLabel.find((tabLabel) => {
              if(tabLabel.code == key){
                tabLabel.count = viewpoint[key];
                return tabLabel
              }
            })
          });
        }
        if (warehouseActive <= this.$parent.limitWarehouses) {
          this.$swal.fire({
            title: this.$t('Congratulations!'),
            text: this.$t('Your store has upgraded subscription.'),
            iconColor: "#FF7043",
            imageUrl: require('@/assets/global_assets/images/inventory/Congratulation.png'), // Replace with your image URL
            imageAlt: 'Custom Image',
            imageWidth: 170, // Adjust width as needed
            imageHeight: 120, // Maintain aspect ratio
            showCancelButton: false,
            confirmButtonText: '<i class="fa-solid fa-circle-check"></i> ' + this.$t("Got It!"),
            focusConfirm: false,
            customClass: {
              confirmButton: "btn btn-primary",
              loader: "custom-loader",
          },
          });
          setTimeout(() => {
            $("#managewarehouse").modal('hide');
            Cookies.set('WmsWarehouseLimit', false, { domain: '.' + process.env.CENTRAL_API_ROOT });
          }, 1000);
        } else {
          this.$refs.vuetable.setData(data);
        }

      } catch (error) {
        console.dir(error)
        switch (Number(error.response.status)) {
          case 403:
              this.hasPermission = false;
              this.loading = "";
            break;
          default:
            this.hasComingSoon = false;
            this.loading = "";
            break;
        }
      }
      this.onload = false;

    },
    NotifyLater(announcement) {
      var t = new Date();
      t.setHours(t.getHours() + 4);
      this.$cookie.set(`notify-later-${announcement.id}`, 1, { expires: t });
    },
    accept(announcementId) {
      Api.Announcement.acceptAnnouncement(announcementId).then((res) => {
        --this.user.announcements;
        Cookies.set('user', JSON.stringify(this.user), { domain: '.' + process.env.CENTRAL_API_ROOT });
      }).catch((err) => {
        console.log(err, 'err');
      });
    },
    showPage(index) {
      this.$refs.carousel.goTo(index - 1);
    },
    toggleCheckboxs(event, dataItem) {
      this.selectedBulk = this.$refs.vuetable.selectedTo;
      if (this.selectedBulk.length == this.$parent.limitWarehouses) {
        if (!this.selectedBulk.includes(dataItem.id)) {
          this.warehouseList.forEach(el=>{
            if (!this.selectedBulk.includes(el.id)) {
              el.disabled = true;
            }
          })
        }
      } else {
        this.warehouseList.forEach(el=>{
          el.disabled = false;
        })
      }

    },
    warehouseStatus: function (status) {
      let statusHtml = '<span class="badge bg-secondary"><i class="fas fa-circle-xmark"></i>' + this.$t('Inactive') + '</span>';
      switch (status) {
        case 'IN_ACTIVE':
          statusHtml = '<span class="badge bg-secondary"><i class="fas fa-circle-xmark"></i>' + this.$t('Inactive') + '</span>';
          break;
        case 'ACTIVE':
          statusHtml = '<span class="badge bg-success-400"><i class="fas fa-check-circle"></i>' + this.$t('Active') + '</span>';
          break;
        default:
          break;
      }
      return statusHtml;
    },
    toggleAllCheckboxes(dataItem, index) {
      this.selectWarehouseAll = dataItem;
      if (dataItem) {
        let findwarehouseDefault = this.$refs.vuetable.selectedTo.filter(el=> el == this.warehouseDefault[0].id);
        if (findwarehouseDefault.length == 0) {
          this.$refs.vuetable.selectedTo.push(this.warehouseDefault[0].id);
        }
        this.$refs.vuetable.selectedTo.splice(1, (this.warehouseIds.length - this.$parent.limitWarehouses));
        this.warehouseList.forEach(el=>{
          el.disabled = false;
          if(!this.$refs.vuetable.selectedTo.includes(el.id)) {
            el.disabled = true;
          }
        })
        this.selectedBulk = this.$refs.vuetable.selectedTo;
      } else {
        this.$refs.vuetable.selectedTo.push(this.warehouseDefault[0].id);
        this.warehouseList.forEach(el=>{
          el.disabled = false;
        })
        this.selectedBulk = this.$refs.vuetable.selectedTo;
      }

    },
    async submitWarehouse () {
      let activeWarehouesLists = this.selectedBulk.filter(id => this.warehouseIds.includes(id));
      let obj = {
        warehouse_ids: activeWarehouesLists,
        usage_warehouse: parseInt(this.totalUsageWarehouse)
      }

      const validateWarehouse = this.warehouseCheckList.some(
        (item) =>
          parseFloat(item.available_qty) > 0 &&
          !activeWarehouesLists.includes(item.id)
      );
      let self = this;

      if (!validateWarehouse) {
        this.$swal.fire({
          title: this.$t("Are You Sure?"),
          iconHtml: '<i class="fa-light fa-circle-exclamation" style="font-weight:300; font-size:6rem;"></i>',
          iconColor: "#FF7043",
          html: `<div class="row mr-2 ml-2 pt-2">
            <div class="col-12 bbbb-soft-pink">
              ${this.$t("Unselected warehouses are automatically marked as inactive and will not be available or updated status until you upgrade your plan.")}
            </div>
          </div>`,
          showCancelButton: true,
          reverseButtons: false,
          confirmButtonText: '<i class="fa-solid fa-check-circle mr-2"></i>' + this.$t("Confirm"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false,
          customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: 'btn btn-light',
              loader: "custom-loader",
          },
          loaderHtml: '<div class="spinner-border text-primary"></div>',
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return await Api.Inventory.manageWarehouse(obj)
              .then((response) => {
                if (response.status == 200) {
                  self.$forceUpdate();
                  self.$toastr.s(
                    self.$t("Manage Plan Usage Success."),
                    "<span class='fa-solid fa-circle-check mr-2'></span>" + self.$t("Success")
                  );
                  self.$swal.close();
                  $('#managewarehouse').modal('hide');
                  Cookies.set('WmsWarehouseLimit', false, { domain: '.' + process.env.CENTRAL_API_ROOT });
                } else {
                  self.$toastr.e(
                    self.$t("Manage Plan Usage Failed."),
                    "<span class='icon-blocked'></span>" + self.$t("Failed")
                  );
                  self.$swal.close();
                }
                setTimeout(function(){
                  self.loading = false;
                  self.$swal.close();
                },1000);
              }).catch((e) => {
                $('#view_modal').modal('hide');
                if(e.response.status === 403 ){
                  self.$swal({
                    icon: false,
                    iconColor: "#FF7043",
                    title: self.$t("Access Denied"),
                    html: self.$t('You do not have permission to access this page.') + '<br/>' + self.$t('If you feel this is a mistake, contact your admin.'),
                    showCancelButton: false,
                    confirmButtonText: '<i class="fa-solid fa-thumbs-up mr-1"></i> ' + self.$t("OK"),

                    imageUrl: require('@/assets/images/activities/icon-access-denied.png'),
                    buttonsStyling: false,
                    customClass: {
                      confirmButton: "btn btn-primary mr-2",
                      cancelButton: "btn btn-light",
                    },
                    focusConfirm: false,
                    showLoaderOnConfirm: true,
                    popup: 'validation-access-denied'
                  })
                }else{
                  self.$toastr.e(
                  self.$t("Something went wrong. Please try again."),
                  "<span class='icon-blocked'></span>" + self.$t("Error")
                );
                }
              });
          },
        });
        $('.fa-triangle-exclamation').closest('.swal2-icon').css("border","unset");
      } else {
        this.$swal.fire({
          title: this.$t('Cannot delete warehouses') + "!",
          iconHtml: '<i class="fa-light fa-circle-exclamation" style="font-weight:300; font-size:6rem;"></i>',
          iconColor: "#FF7043",
          html: `<div class="row mr-2 ml-2 pt-2">
            <div class="col-12 bbbb-soft-pink">
              ${this.$t("There are quantity remaining in unselected warehouse. Please transfer the quantity before confirming this selection.")}
            </div>
          </div>`,
          showCancelButton: false,
          confirmButtonText: '<i class="fa-solid fa-circle-check"></i> ' + this.$t("Got It!"),
          focusConfirm: false,
          customClass: {
            confirmButton: "btn btn-primary",
            loader: "custom-loader",
          },
        });
      }
    }
  },
};
</script>

<style scoped>
.button-container {
  border-top: 1px solid #dbdbdb;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.btn-page-contain {
  width: 22px;
  height: 22px;
  border-radius: 22px;
  border: 1px solid #a2adb1;
  background-color: transparent !important;
  text-align: center;
  vertical-align: middle;
  line-height: 15px;
}

.btn-page-contain:hover {
  cursor: pointer !important;
}

.btn-page-label {
  font-size: 9px;
  color: #a2adb1;
  vertical-align: middle !important;
}

.btn-page-contain-active {
  border: 1px solid #2196f3;
  background-color: #2196f3 !important;
}

.btn-page-label-active {
  font-size: 9px;
  /* line-height: 15px; */
  color: #fff;
}

.btn-page-contain-active:hover {
  cursor: pointer !important;
}
.checkbok-combine > td > input {
  opacity: 0.5;
}
.disabled input[type="checkbox"] {
    pointer-events: none; /* Disable pointer events */
    opacity: 0.5; /* Optionally reduce opacity */
  }
</style>




// WEBPACK FOOTER //
// src/layouts/tenancy/admin/ManageWarehouse.vue